/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Order { 
    address?: string;
    archived?: boolean;
    city?: string;
    createdAt?: string;
    email?: string;
    firstName?: string;
    id?: string;
    importObjectKey?: string;
    importSessionKey?: string;
    lastName?: string;
    locked?: boolean;
    phoneNumber?: string;
    product?: string;
    published?: boolean;
    readOnly?: boolean;
    sentTrackingInfo?: boolean;
    state?: string;
    trackingNumber?: string;
    updatedAt?: string;
    version?: number;
    zip?: number;
}
